module.exports = __webpack_public_path__ + "img/banner.e33f4352.jpg";